import { Quote } from "lucide-react";
import { useLang } from "@/i18n";
import Reveal from "./Reveal";

const Testimonials = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="opiniones"
      data-testid="testimonials-section"
      className="bg-grid-light relative border-t border-black/10 bg-bone py-28 lg:py-36"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <Reveal>
          <div className="mb-16 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p
                data-testid="testimonials-eyebrow"
                className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta"
              >
                {t.reviews.eyebrow}
              </p>
              <h2
                data-testid="testimonials-heading"
                className="mt-5 font-display text-3xl font-medium tracking-tight text-charcoal sm:text-4xl"
              >
                {t.reviews.heading}
              </h2>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-stone-500">
              {t.reviews.sub}
            </p>
          </div>
        </Reveal>

        <div className="grid gap-px border border-black/10 bg-black/10 lg:grid-cols-3" data-testid="testimonials-grid">
          {t.reviews.items.map((r, i) => (
            <Reveal key={`${lang}-rev-${i}`} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="group flex h-full flex-col justify-between bg-bone p-8 transition-colors duration-500 hover:bg-travertine lg:p-10"
              >
                <div>
                  <div className="flex items-center justify-between">
                    <Quote size={22} strokeWidth={1.4} className="rotate-180 text-terracotta" />
                    <span className="font-mono text-[11px] tracking-[0.25em] text-stone-400">
                      R.0{i + 1}
                    </span>
                  </div>
                  <blockquote className="mt-8 font-display text-xl font-medium italic leading-relaxed text-charcoal">
                    “{r.text}”
                  </blockquote>
                </div>
                <figcaption className="mt-10 border-t border-black/10 pt-5">
                  <p className="font-mono text-xs uppercase tracking-[0.18em] text-charcoal">
                    {r.name}
                  </p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-terracotta">
                    {r.job}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
